import LayoutConfirmationModal from './LayoutConfirmationModal';

export default LayoutConfirmationModal;
